<div class="commandCenterTableGrid">
  <div class="newLandingPageOrdersTabSection">
    <div class="order-top-sec">
      <div class="" [ngStyle]="{'display': isSeedOrderAccess || isCPPOrderAccess ? '' : 'none'}">

        <div class="dropdownSectionOne">

          <button mat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" class="selectDateRange text-left">
            {{filter.dateRangeText}} <i class="arrow down"></i>
          </button>
          <mat-menu #menu="matMenu" class="dropdown-content-new" style="min-width: 176px;">
            <button mat-menu-item (click)="setDateFilter(1,'Last 1 day',1,null)">Last 1 day</button>
            <button mat-menu-item (click)="setDateFilter(1,'Last 7 days',7,null)">Last 7 days</button>
            <button mat-menu-item (click)="setDateFilter(1,'Last 30 days',30,null)">Last 30 days</button>
            <button mat-menu-item (click)="setDateFilter(1,'Last 90 days',90,null)">Last 90 days</button>
            <button mat-menu-item class="btn dropdown-toggle" (click)="$event.stopPropagation();picker.open()">
              Custom:
              <mat-form-field>
                <mat-date-range-input #dateRangeInput [rangePicker]="picker" [min]="minOrderDate" [max]="maxOrderDate">
                  <input matStartDate #startDate matInput placeholder="Start date" (dateChange)="setDateFilter(2, 'Custom Date',0, $event)" />
                  <input matEndDate #endDate matInput placeholder="End date" (dateChange)="setDateFilter(3,'Custom Date',0, $event)" />
                </mat-date-range-input>

                <mat-date-range-picker #picker [opened]="isPickerOpen" (closed)="onPickerClosed()">
                </mat-date-range-picker>
              </mat-form-field>
            </button>
          </mat-menu>
        </div>


        <div class="paginatonSection">
          <mat-paginator #otiOrdersPaginator [pageSize]="20" [pageSizeOptions]="[10, 20, 30, 50]"
                         aria-label="Select page of CPP Orders"></mat-paginator>

        </div>
      </div>
    </div>
    <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs margin-t10" (selectedTabChange)="tabChanged($event)" [selectedIndex]="currentTab">
      <mat-tab label="0" *ngIf="isCPPOrderAccess">
        <ng-template mat-tab-label>
          <i class="icon-ico-grower_icon" aria-hidden="true"></i>
          <div class="tab-head">
            <h4 class="tab-head">
              Crop Protection Orders
            </h4>
            <p class="subhead">
              View in-transit orders
            </p>

          </div>
          <i class="icon-ico-check" aria-hidden="true"></i>
        </ng-template>
        <div class="tableContainer dealertableContainer col-12">
          <table mat-table [dataSource]="otiOrdersDataSource" multiTemplateDataRows class="matTables newLandingPageTable">

            <ng-container matColumnDef="webOrderNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Web Order Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.webOrderNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderNumber}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="productName">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Product Name </th>
              <td mat-cell *matCellDef="let element" class="text-left"> <span style="width: 80%;">{{element.productName}}</span>
              <span *ngIf ="element.isBIO" style="width: 20%;"><img src="../../../../assets/icon/svg/WU_Bioverified_Green.png" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" /></span> </td>
            </ng-container>

            <ng-container matColumnDef="vendor">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Vendor</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.vendor}} </td>
            </ng-container>

            <ng-container matColumnDef="shipToLocation">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Ship-To Location</th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <div class="order-info defaultCursor">
                  <p class="grower-name">
                    {{element.accountName}}
                  </p>
                  <!--<p class="growerAddress">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>-->
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="deliveredQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Shipped Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.deliveredQty}} </td>
            </ng-container>

            <ng-container matColumnDef="UOM">
              <th mat-header-cell *matHeaderCellDef class="text-center"> UOM </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.uom}} </td>
            </ng-container>

            <ng-container matColumnDef="orderStatus">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
              <td mat-cell *matCellDef="let element" class="text-center yellowBg">
                {{element.orderStatus}}
                <span *ngIf="element.orderStatus?.toLowerCase() === 'shipped in transit' && element.trackingURL">
                  <i class="fa fa-info-circle" [matTooltip]="shippedInTransitMessage" [matTooltipPosition]="'above'"></i>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="trackingURL">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Tracking </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span> <a *ngIf="element.trackingURL" href="{{element.trackingURL}}" target="_blank"><img src="../../../../assets/icon/svg/shippingStatus.svg" class="truckImg" alt="truck-image" /></a> </span>

              </td>

            </ng-container>
            <tr mat-header-row *matHeaderRowDef="orderColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: orderColumns;"
                class="example-element-row"></tr>
            <!--<tr mat-footer-row *matFooterRowDef="['trackingURL']" class="footer-row" [ngClass]="(otiOrdersDataSource?.data?.length < 6) ?'moveDown':''"></tr>-->
          </table>
          <div *ngIf="otiOrdersDataSource == undefined || otiOrdersDataSource?.data?.length <= 0" class="noDataMsg">
            <p class="padding-b47">No orders to display at this time.</p>
          </div>
        </div>
        <div class="totalCountRow" [ngClass]="chatAccess ? 'increasePadding':''">
          <div class="paginatonSection">
            <mat-paginator #otiOrdersPaginator [pageSize]="20" [pageSizeOptions]="[10, 20, 30, 50]"
                           aria-label="Select page of CPP Orders"></mat-paginator>
  
          </div>
          <div>
            SHIPPED (IN TRANSIT) RECORDS <span class="dataCount">{{dataCount}}</span><span> <a (click)="navigatetoViewOrderWithFilters()">VIEW ALL</a></span>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="1" *ngIf="isSeedOrderAccess">
        <ng-template mat-tab-label>
          <i class="icon-ico-grower_icon" aria-hidden="true"></i>
          <div class="tab-head">
            <h4 class="tab-head">
              Seed Orders
            </h4>
            <p class="subhead">
              View in-transit orders
            </p>

          </div>
          <i class="icon-ico-check" aria-hidden="true"></i>
        </ng-template>
        <div class="tableContainer seedOrdersTable col-12">
          <table mat-table [dataSource]="otiOrdersDataSource" multiTemplateDataRows class="matTables newLandingPageTable">

            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Number</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="customerPO">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Customer PO# </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.customerPO}} </td>
            </ng-container>
            <ng-container matColumnDef="orderDate">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Order Date </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderDate | date:'MM/dd/yyyy'}}</td>
            </ng-container>
            <ng-container matColumnDef="itemDescription">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Item Description</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.productName}} </td>
            </ng-container>
            <ng-container matColumnDef="marketingBrand">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Marketing Brand</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.vendor}} </td>
            </ng-container>
            <ng-container matColumnDef="shipToLocation">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Ship-To Location</th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <div class="order-info defaultCursor">
                  <p class="grower-name">
                    {{element.accountName}}
                  </p>
                  <!--{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}-->
                </div>
              </td>

            </ng-container>

            <ng-container matColumnDef="orderedQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Ordered Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderedQty}} </td>
            </ng-container>

            <ng-container matColumnDef="deliveredQty">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Delivered Qty </th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.deliveredQty}} </td>
            </ng-container>
            <ng-container matColumnDef="orderStatus">
              <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
              <td mat-cell *matCellDef="let element" class="text-center yellowBg">
                {{element.orderStatus}}
                <span *ngIf="element.orderStatus?.toLowerCase() === 'shipped in transit' && element.trackingURL">
                  <i class="fa fa-info-circle" [matTooltip]="shippedInTransitMessage" [matTooltipPosition]="'above'"></i>
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="trackingURL">
              <th mat-header-cell *matHeaderCellDef class="text-left"> Tracking </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span> <a *ngIf="element.trackingURL" href="{{element.trackingURL}}" target="_blank"><img src="../../../../assets/icon/svg/shippingStatus.svg" class="truckImg" alt="truck-image" /></a> </span>
              </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="seedOrderColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: seedOrderColumns;"
                class="example-element-row"
                [class.example-expanded-row]="element && element.selected"></tr>
            <!--<tr mat-footer-row *matFooterRowDef="['trackingURL']" class="footer-row" [ngClass]="(otiOrdersDataSource?.data?.length < 6) ?'moveDown':''"></tr>-->
          </table>
          <div *ngIf="otiOrdersDataSource == undefined || otiOrdersDataSource?.data?.length <= 0" class="noDataMsg">
            <p class="padding-b47">No orders to display at this time.</p>
          </div>

        </div>
        <div class="totalCountRow" [ngClass]="chatAccess ? 'increasePadding':''">
          <div class="paginatonSection">
            <mat-paginator #otiOrdersPaginator [pageSize]="20" [pageSizeOptions]="[10, 20, 30, 50]"
                           aria-label="Select page of CPP Orders"></mat-paginator>
  
          </div>
          <div>
            SHIPPED (IN TRANSIT) RECORDS <span class="dataCount">{{dataCount}}</span><span> <a (click)="navigatetoViewOrderWithFilters()">VIEW ALL</a></span>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

